import { CalendarToday } from "@mui/icons-material";
import PersonIcon from "@mui/icons-material/Person";
import { Box, Card, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import moment from "moment";
import "moment/locale/id";
import React from "react";
import { ContentGetRoomListExclusive } from "../../constants/types";
import toRupiah from "../../utils/toRupiah";
import ModalDetailRuanganKhusus from "../ModalDetailRuanganKhusus/ModalDetailRuanganKhusus";

interface ICardRoomProps {
    data: ContentGetRoomListExclusive;
}

const CardRoom = ({
    data
}: ICardRoomProps) => {
    const theme = useTheme();
    const isTabletScreen = useMediaQuery(theme.breakpoints.between("md", "lg"));

    // const {
    //     id,
    //     nama,
    //     kapasitas,
    //     jenisSewa,
    //     hargaSewaMember,
    //     hargaSewaNonMember,
    //     hargaCustom,
    //     status,
    //     penyewa,
    //     ukm,
    //     isAktif,
    //     isBooked,
    //     penyewaMendatang,
    // } = data;

    const {
        id,
        nama,
        kapasitas,
        hargaCustom,
        hargaSewaMember,
        hargaSewaNonMember,
        status,
        isAktif,
        isBooked,
        jenisSewa,
        penyewa,
        penyewaMendatang,
        ukm,
    } = data;

    const endDate = penyewa?.periode
        ? penyewa.periode.split(" - ")[1]
        : null;

    const calculateRemainingTime = (endDate: string): string => {
        const now = moment();
        const end = moment(endDate);
        
        if (end.isBefore(now)) {
            return "Masa Sewa Habis";
        }

        const years = end.diff(now, 'years');
        const months = end.subtract(years, 'years').diff(now, 'months');
        const days = end.subtract(months, 'months').diff(now, 'days');

        const parts = [];
        
        if (years > 0) {
            parts.push(`${years} Tahun`);
        }
        if (months > 0) {
            parts.push(`${months} Bulan`);
        }
        if (days > 0 && parts.length < 2) {
            parts.push(`${days} Hari`);
        }

        return parts.length > 0 ? `Sisa ${parts.join(' ')}` : "Kurang dari 1 Hari";
    };

    const sisaWaktu: string | null = endDate
        ? calculateRemainingTime(endDate)
        : null;

    const [isOpenModalDetailRuanganKhusus, setIsOpenModalDetailRuanganKhusus] =
        React.useState(false);

    const openModalDetailRuanganKhusus = () => setIsOpenModalDetailRuanganKhusus(true);
    const closeModalDetailRuanganKhusus = () => setIsOpenModalDetailRuanganKhusus(false);

    const getChipColor = () => {
        if (isAktif === 0) {
            return "#A8B4AF";
        }
        
        if (status === "Tersedia") {
            return "#119C5B";
        }
        
        if (!endDate) {
            return "#0A5BBB";
        }

        const now = moment();
        const end = moment(endDate);
        const daysRemaining = end.diff(now, 'days');

        if (daysRemaining <= 30) {
            return "#D32F2F";
        } else if (daysRemaining <= 90) {
            return "#FF9800";
        } else {
            return "#0A5BBB";
        }
    };

    const formatPeriodeMendatang = (periode: string) => {
        if (!periode) return "";
        
        const [startDate, endDate] = periode.split(" - ");
        const formattedStart = moment(startDate).locale("id").format("D MMMM YYYY");
        const formattedEnd = moment(endDate).locale("id").format("D MMMM YYYY");
        
        return `${formattedStart} – ${formattedEnd}`;
    };

    const getHargaUnit = () => {
        switch (jenisSewa) {
            case "jam":
                return "/Jam";
            case "mingguan":
                return "/Minggu";
            case "bulanan":
            default:
                return "/Bulan";
        }
    };

    const getHargaTampil = () => {
        if (hargaCustom) {
            return toRupiah(hargaCustom);
        }
        
        if (jenisSewa === "mingguan") {
            return toRupiah(hargaSewaMember || 0);
        }
        
        return toRupiah(hargaSewaMember || 0);
    };

    return (
        <Card
            onClick={() => openModalDetailRuanganKhusus()}
            sx={{
                cursor: isOpenModalDetailRuanganKhusus ? "default" : "pointer",
                pointerEvents: isOpenModalDetailRuanganKhusus ? "none" : "auto",
                padding: isTabletScreen ? 1 : 2,
                backgroundColor: "#F2F2F2"
            }}
        >
            <Box>
                <Stack
                    direction="row"
                    // justifyContent="space-between"
                    // flexWrap="wrap"
                    gap={2}
                >
                    <Stack>
                        <Typography variant="body1" fontWeight={600}>
                            {nama}
                        </Typography>
                    </Stack>
                    
                    <Stack direction="row" spacing={1}>
                        <Box>
                            <Stack
                                direction="row"
                                alignItems="center"
                                justifyContent="center"
                                padding="4px 12px"
                                sx={{
                                    backgroundColor: getChipColor(),
                                    borderRadius: "200px",
                                }}
                            >
                                <Typography color="white" fontSize="14px">
                                    {isAktif === 0 
                                        ? "Nonaktif" 
                                        : status === "Tersedia"
                                            ? "Tersedia"
                                            : sisaWaktu || "-"
                                    }

                                    {/* {status === "Tersedia"
                                        ? "Tersedia"
                                        : sisaWaktu || "-"} */}
                                </Typography>
                            </Stack>
                        </Box>

                        <Box>
                            {isBooked === 1 && (
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="center"
                                    padding="4px 12px"
                                    sx={{
                                        border: "1px solid #0A5BBB",
                                        borderRadius: "200px",
                                    }}
                                >
                                    <Typography color="#0A5BBB" fontSize="14px">
                                        Booked
                                    </Typography>
                                </Stack>
                            )}
                        </Box>
                    </Stack>
                </Stack>

                <Stack
                    direction="row"
                    justifyContent="space-between"
                    flexWrap="wrap"
                    alignItems="center"
                    mt={1}
                >
                    <Stack direction="column" spacing={1}>
                        <Typography variant="subtitle2" color="text.secondary">
                            Kapasitas {kapasitas} Orang
                        </Typography>

                        <Stack direction="row" spacing={2} alignItems="center">
                            {/* Penyewa */}
                            <Stack direction="row" alignItems="center" spacing={1}>
                                <PersonIcon fontSize="small" color="action" />
                                {penyewa ? (
                                    <Typography variant="body2">
                                        {penyewa.pic} • {penyewa.nama}{" "}
                                        <a href={`tel:${penyewa.teleponPic}`}>{penyewa.teleponPic}</a>
                                    </Typography>
                                ) : (
                                    <Typography variant="body2" color="text.secondary">
                                        Belum ada penyewa
                                    </Typography>
                                )}
                            </Stack>

                            {/* Tanggal Sewa */}
                            <Stack direction="row" alignItems="center" spacing={1}>
                                <CalendarToday fontSize="small" color="action" />

                                {penyewa ? (
                                    <Typography variant="body2">
                                        {(() => {
                                            const [startDate, endDate] = penyewa.periode.split(" - ");
                                            const formattedStart = moment(startDate).locale("id").format("D MMMM YYYY");
                                            const formattedEnd = moment(endDate).locale("id").format("D MMMM YYYY");
                                            return `${formattedStart} - ${formattedEnd}`;
                                        })()}
                                    </Typography>
                                ) : status === "Tersedia" && penyewaMendatang ? (
                                    <Typography variant="body2">
                                        Akan digunakan: {formatPeriodeMendatang(penyewaMendatang.periode)}
                                    </Typography>
                                ) : (
                                    <Typography variant="body2" color="text.secondary">
                                        -
                                    </Typography>
                                )}
                            </Stack>
                        </Stack>
                    </Stack>

                    <Stack>
                        {/* Harga */}
                        <Typography
                            variant="body1"
                            fontWeight={600}
                            color="purple"
                            mt={2}
                            textAlign="right"
                        >
                            {getHargaTampil()}{getHargaUnit()}
                        </Typography>
                    </Stack>
                </Stack>

                <ModalDetailRuanganKhusus
                    isOpenModalDetailRuanganKhusus={isOpenModalDetailRuanganKhusus}
                    closeModalDetailRuanganKhusus={closeModalDetailRuanganKhusus}
                    ukm={ukm}
                    roomId={id}
                    nama={nama}
                    kapasitas={kapasitas}
                    jenisSewa={jenisSewa}
                    isAktif={isAktif}
                    hargaSewaMember={hargaSewaMember}
                    hargaSewaNonMember={hargaSewaNonMember}
                />
            </Box>
        </Card>
    );
};

export default CardRoom;